<template>
    <div class="p-4 bg-gray-200/5 rounded-2xl">
        <p v-if="label" class="text-xs font-bold text-header mb-2">
            {{ label }} <span class="text-body/80 font-medium">(optional)</span>
        </p>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <template v-for="f in fields" :key="f.key">
                <template v-if="collectedData.includes(f.key)">
                    <label class="block">
                        <span class="text-xs font-bold text-body/80 uppercase tracking-wider">{{ f.label }}</span>
                        <template v-if="f.type == 'tel'">
                            <PhoneInput v-model="holder[f.key]" :class="fieldClass"></PhoneInput>
                        </template>
                        <template v-else>
                            <input :value="holder[f.key]" :type="f.type" :class="fieldClass"
                                @input="update(f.key, ($event.target as HTMLInputElement).value.trim())" />
                        </template>
                    </label>
                </template>
            </template>
        </div>
        <div class="flex mt-2">
            <!-- <div @click="enableCollection('name')" class="px-2 cursor-pointer">Add name</div> -->
            <div @click="enableCollection('phone')" class="px-2 cursor-pointer">Add phone</div>
            <div @click="enableCollection('email')" class="px-2 cursor-pointer">Add email</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import PhoneInput from '@core/forms/PhoneInput.vue';
import { TicketHolder } from '~/types';
import { reactive, ref } from 'vue';

const props = defineProps<{ holder: TicketHolder; label?: string }>();
const emit = defineEmits<{ (e: 'update:holder', value: TicketHolder): void }>();

const fieldClass =
    'mt-1.5 w-full rounded-xl form-control transition-all';

const collectedData = reactive<string[]>(['firstName','lastName'])
const fields: { key: keyof TicketHolder; label: string; type: string }[] = [
    { key: 'firstName', label: 'First name', type: 'text' },
    { key: 'lastName', label: 'Last name', type: 'text' },
    { key: 'phone', label: 'Phone', type: 'tel' },
    { key: 'email', label: 'Email', type: 'email' },
];

const update = (key: keyof TicketHolder, value: string) => emit('update:holder', { ...props.holder, [key]: value });

const enableCollection = (key: string) => {
    if(key == 'name') {
        enableCollection('firstName');
        enableCollection('lastName');
    } else {
        let pos = collectedData.indexOf(key);
        if(pos > -1) {
            collectedData.splice(pos, 1);
        } else {
            collectedData.push(key);
        }
    }
    
}
</script>

<style scoped>
.border-app {
    border-color: rgb(var(--core-app-border));
}

.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.text-header {
    color: rgb(var(--core-header-text));
}

.text-muted {
    color: rgb(var(--core-muted-text));
}
</style>
